import surveyAllowUrl from '../constant/surveyAllowUrl';
import msDataProvider from "@/services/msDataProvider";
import merge from "deepmerge";

class SurveyService {
  private settings: any = {}

  public async watchRoute(from, to) {
    if (from && surveyAllowUrl.ALLOW_FROM_URLS.includes(from.path) && surveyAllowUrl.ALLOW_TO_URLS.includes(to.path)) {
      const res = await msDataProvider.getData("userData")
      const resClientSetting = await msDataProvider.getData("clientSetting")
      let countActiveApp: number = 0
      let countSkipSurvey: number = 0
      let afterOpen: number = 0
      let userData: any = {}
      let settings: any = {}
      let key: string = ''
      if (resClientSetting && resClientSetting.settings) {
        settings = resClientSetting.settings
      }
      if (settings && settings.survey) {

        if (settings.survey.after_open) {
          afterOpen = settings.survey.after_open
        }
        if (settings.survey.link) {
          key = settings.survey.link
        }
      }
      if (res) {
        userData = res
        if (res.data && res.data[key] && res.data[key].countActiveApp) {
          countActiveApp = res.data[key].countActiveApp
        }
        if (res.data && res.data[key] && res.data[key].countSkipSurvey) {
          countSkipSurvey = res.data[key].countSkipSurvey
        }
      }
      let params = {
        data: {
          [key]: {
            'countActiveApp': countActiveApp !== afterOpen
              ? countActiveApp + 1
              : countActiveApp,
            'countSkipSurvey': countSkipSurvey
          }
        }
      }
      params = merge(userData, params)
      return params
    }
  }

  public async setSettings() {
    const res = await msDataProvider.getData("clientSetting")
    let key: string = ''
    let afterOpen: number = 0
    let maxIgnore: number = 0
    let title: string = ''
    let subTitle: string = ''
    if (res && res.settings) {
      this.settings = res.settings
    }
    if (this.settings && this.settings.survey) {

      if (this.settings.survey.after_open) {
        afterOpen = this.settings.survey.after_open
      }
      if (this.settings.survey.link) {
        key = this.settings.survey.link
      }
      if (this.settings.survey.max_ignore) {
        maxIgnore = this.settings.survey.max_ignore
      }
      if (this.settings.survey.title) {
        title = this.settings.survey.title
      }
      if (this.settings.survey.sub_title) {
        subTitle = this.settings.survey.sub_title
      }
    }
    return { afterOpen, key, maxIgnore, title, subTitle }
  }

}

export default new SurveyService()
